import React, { useEffect, useState } from "react";
import ViewAppBar from "../views/ViewAppBar";
import ViewFooter from "../views/ViewFooter";
import Globais, { validateToken } from "../components/Globais";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";
import { useMessage } from "../uteis/mensagens/useMessage";
import axios from "axios";
import styled from "styled-components";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const BackButton = styled.button`
  position: absolute;
  top: 110px;
  left: 40px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 50%;
  padding: 0.6rem;
  cursor: pointer;
  color: #fff;
  transition: background 0.3s ease, transform 0.2s ease;
  z-index: 20;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.05);
  }

  svg {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 768px) {
    top: 90px;
    left: 20px;
    padding: 0.5rem;
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

const Marketing: React.FC = () => {
  const { isLoading, isValid } = usePermissao("OPE");
  const { showSuccess, showError, contextHolder } = useMessage();
 const navigate = useNavigate();
  const [apiStatus, setApiStatus] = useState<"online" | "offline" | "loading">(
    "loading"
  );
  const [loadingCron, setLoadingCron] = useState(false);
      const [token, setToken] = useState<any>(null);
  const [checkingToken, setCheckingToken] = useState(true);
  const [statusCron, setStatusCron] = useState("loading");
const [loadingGerador, setLoadingGerador] = useState(false);
     

  // 🔑 Token de autenticação
// ↪ VALIDAR TOKEN
  useEffect(() => {
    const loadToken = async () => {
      const t = await validateToken();
      if (!t) {
        window.location.href = Globais.DOMINIOFRONT + "/login";
        return;
      }
      setToken(t);
      setCheckingToken(false);
    };

    loadToken();
  }, []);

  // ↪ CONSULTAR STATUS WHATSAPP
  useEffect(() => {
    if (!token) return;

    const fetchStatus = async () => {
      try {
        const response = await axios.get(
          `${Globais.DOMINIOBACK}/utils/verificar-whatsapp`,
          { headers: { Authorization: token.AuthStr } }
        );

        setApiStatus(response.data.success ? "online" : "offline");
      } catch {
        setApiStatus("offline");
      }
     
    };
    const fetchCronStatus = async () => {
    try {
      const response = await getCronGeradorStatus(token);

      setStatusCron(response.data.status === "error" ? "error" : "success");
    } catch (error) {
      setStatusCron("error");
    }
  };

    fetchStatus();
    fetchCronStatus();
  }, [token]);

  

  const reexecutarCron = async () => {
    try {
      setLoadingCron(true);

      await axios.post(
        `${Globais.DOMINIOBACK}/cron/rodada_manual`,
        {},
        { headers: { Authorization: token.AuthStr } }
      );

      showSuccess("Cron reexecutado com sucesso! 🚀");
    } catch {
      showError("Erro ao tentar reexecutar o cron.");
    } finally {
      setLoadingCron(false);
    }
  };
  const reexecutarCronMensagens = async () => {
    try {
      setLoadingCron(true);

      await axios.post(
        `${Globais.DOMINIOBACK}/cron/mensagens/executar`,
        {},
        { headers: { Authorization: token.AuthStr } }
      );

      showSuccess("Cron reexecutado com sucesso! 🚀");
    } catch {
      showError("Erro ao tentar reexecutar o cron.");
    } finally {
      setLoadingCron(false);
    }
  };

 const getCronGeradorStatus = async(token: any)=>{
  return axios.get(
    `${Globais.DOMINIOBACK}/cron-execution/status/geradorMensagens`,
    { headers: { Authorization: token.AuthStr } }
  );
}

  const handleVoltar = () => navigate("/inicio");

  const badgeStyle =
    apiStatus === "online"
      ? { text: "Online", backgroundColor: "#28a745" }
      : apiStatus === "offline"
      ? { text: "Offline", backgroundColor: "#dc3545" }
      : { text: "Verificando...", backgroundColor: "#999" };





    if (isLoading) return <p>Verificando permissão...</p>;
  if (!isValid) return null;

  return (
    <>
      <ViewAppBar />
      
      {contextHolder}
       {checkingToken && <p>Validando acesso...</p>}
      {!checkingToken && isLoading && <p>Verificando permissão...</p>}
      {!checkingToken && !isLoading && !isValid && <p>Sem permissão.</p>}

      {!checkingToken && isValid && (
        
        <>
      <BackButton onClick={handleVoltar} title="Voltar">
        <ArrowLeft />
      </BackButton>

      <main className="card-grid" style={{ marginTop: "2rem" }}>
        
        {/* Gerenciar Leads */}
        <div className="card">
          <div style={{ textAlign: "center" }}>
            <i className="fas fa-user-plus" style={{ fontSize: "2rem", color: "#003644" }}></i>
          </div>
          <h2>Gerenciar Pessoas</h2>
          <p>Visualize e gerencie as pessoas cadastradas.</p>
          <a href={Globais.DOMINIOFRONT + "/gerenciarPessoas"}>Gerenciar</a>
        </div>

        {/* Gerenciar Modelos */}
        <div className="card">
          <div style={{ textAlign: "center" }}>
            <i className="fas fa-bullhorn" style={{ fontSize: "2rem", color: "#003644" }}></i>
          </div>
          <h2>Gerenciar Modelos de Campanhas</h2>
          <p>Crie e edite os modelos usados nas campanhas de marketing.</p>
          <a href={Globais.DOMINIOFRONT + "/gerenciarModeloCampanhas"}>Gerenciar</a>
        </div>

        {/* Gerenciar Etiquetas */}
        <div className="card">
          <div style={{ textAlign: "center" }}>
            <i className="fas fa-tags" style={{ fontSize: "2rem", color: "#003644" }}></i>
          </div>
          <h2>Gerenciar Etiquetas</h2>
          <p>Organize as etiquetas usadas nas campanhas e nos leads.</p>
          <a href={Globais.DOMINIOFRONT + "/gerenciarEtiquetas"}>Gerenciar</a>
        </div>

        {/* Gerenciar Postagens */}
        <div className="card">
          <div style={{ textAlign: "center" }}>
            <i className="fas fa-file-lines" style={{ fontSize: "2rem", color: "#003644" }}></i>
          </div>
          <h2>Gerenciar Postagens</h2>
          <p>Visualize e edite postagens publicadas no sistema.</p>
          <a href={Globais.DOMINIOFRONT + "/gerenciarPostagens"}>Gerenciar</a>
        </div>

        {/* Gerenciar Categorias */}
        <div className="card">
          <div style={{ textAlign: "center" }}>
            <i className="fas fa-envelope-open-text" style={{ fontSize: "2rem", color: "#003644" }}></i>
          </div>
          <h2>Gerenciar Categorias de Mensagem</h2>
          <p>Adicione, edite e organize as categorias das mensagens.</p>
          <a href={Globais.DOMINIOFRONT + "/gerenciarCategoriaMensagens"}>Gerenciar</a>
        </div>

        {/* 📲 Mensageria / WhatsApp */}
        <div className="card" style={{ position: "relative" }}>
          <span
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              padding: "4px 10px",
              borderRadius: "12px",
              fontSize: "12px",
              fontWeight: "bold",
              color: "white",
              backgroundColor: badgeStyle.backgroundColor,
            }}
          >
            {badgeStyle.text}
          </span>

          <div style={{ textAlign: "center" }}>
            <i className="fab fa-whatsapp" style={{ fontSize: "2rem", color: "#25D366" }}></i>
          </div>

          <h2>Mensageria / WhatsApp</h2>
          <p>Reexecute o cron de disparo quando a API estiver inativa.</p>

          <button
            onClick={reexecutarCron}
            disabled={loadingCron}
            style={{
              padding: "10px 20px",
              fontSize: "14px",
              backgroundColor: "#25D366",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              opacity: loadingCron ? 0.7 : 1,
            }}
          >
            {loadingCron ? "Reiniciando..." : "Reexecutar Cron"}
          </button>
        </div>
        {/* 📡 Gerador de Mensagens */}
    <div className="card" style={{ position: "relative" }}>
      {statusCron === "error" && (
        <span
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            padding: "4px 10px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: "bold",
            color: "white",
            backgroundColor: "#dc3545",
          }}
        >
          Erro
        </span>
      )}

      {statusCron === "success" && (
        <span
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            padding: "4px 10px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: "bold",
            color: "white",
            backgroundColor: "#28a745",
          }}
        >
          OK
        </span>
      )}

      <div style={{ textAlign: "center" }}>
        <i className="fas fa-envelope" style={{ fontSize: "2rem", color: "#003644" }}></i>
      </div>

      <h2>Gerador de Mensagens</h2>
      <p>
        Verifica o status do cron responsável por gerar mensagens diariamente.
      </p>

      <button
        onClick={reexecutarCronMensagens}
        disabled={loadingGerador}
        style={{
          padding: "10px 20px",
          fontSize: "14px",
          backgroundColor: "#003644",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          opacity: loadingGerador ? 0.7 : 1,
        }}
      >
        {loadingGerador ? "Executando..." : "Executar Manualmente"}
      </button>
    </div>

      </main>
      </>
      )}
    

      <ViewFooter />
      
    </>
  ); 
};

export default Marketing;
